<template>
  <div class="transaction-parameter">
    <div class="setting-box">
      <div class="title">交易流程类参数</div>
      <el-table :data="settingsData" border>
        <el-table-column
          prop="displayName"
          label="参数项"
          width="200"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column label="参数值" :resizable="false">
          <template slot-scope="scope">
            <span
              v-for="(item, index) in scope.row.value"
              :key="index"
              class="setting-value"
              :class="{ 'setting-default': item.isDefault }"
            >
              {{ item.option
              }}<span v-if="index != scope.row.value.length - 1">、</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="60"
          :resizable="false"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">修改</el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="loading-box" v-if="isLoading">
            <img
              src="../../../../assets/image/loading.png"
              alt="loading"
              class="loading-ico"
            />
            数据加载中...
          </div>
          <div class="empty-box" v-if="!isLoading && !settingData.length">
            列表为空
          </div>
        </template>
      </el-table>
    </div>
    <div class="setting-box">
      <div class="title">业绩分成类参数</div>
      <el-table :data="settingsAchievementPlanParamData" border>
        <el-table-column
          prop="displayName"
          label="参数项"
          width="200"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column label="参数值" :resizable="false">
          <template slot-scope="scope">
            <span
              v-for="(item, index) in scope.row.value"
              :key="index"
              class="setting-value"
              :class="{ 'setting-default': item.isDefault }"
            >
              {{ item.option
              }}<span v-if="index != scope.row.value.length - 1">、</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="60"
          :resizable="false"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">修改</el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="loading-box" v-if="isLoading">
            <img
              src="../../../../assets/image/loading.png"
              alt="loading"
              class="loading-ico"
            />
            数据加载中...
          </div>
          <div class="empty-box" v-if="!isLoading && !settingData.length">
            列表为空
          </div>
        </template>
      </el-table>
    </div>
    <div class="setting-box">
      <div class="title">资金类参数</div>
      <el-table :data="settingsCapitalParamData" border>
        <el-table-column
          prop="displayName"
          label="参数项"
          width="200"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column label="参数值" :resizable="false">
          <template slot-scope="scope">
            <span
              v-for="(item, index) in scope.row.value"
              :key="index"
              class="setting-value"
              :class="{ 'setting-default': item.isDefault }"
            >
              {{ item.option
              }}<span v-if="index != scope.row.value.length - 1">、</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="60"
          :resizable="false"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">修改</el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="loading-box" v-if="isLoading">
            <img
              src="../../../../assets/image/loading.png"
              alt="loading"
              class="loading-ico"
            />
            数据加载中...
          </div>
          <div class="empty-box" v-if="!isLoading && !settingData.length">
            列表为空
          </div>
        </template>
      </el-table>
    </div>
    <div class="setting-box last">
      <div class="title">附件参数</div>
      <el-table :data="settingsMaterialParamData" border>
        <el-table-column
          prop="displayName"
          label="参数项"
          width="200"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column label="参数值" :resizable="false">
          <template slot-scope="scope">
            <span
              v-for="(item, index) in scope.row.value"
              :key="index"
              class="setting-value"
              :class="{ 'setting-default': item.isDefault }"
            >
              {{ item.option
              }}<span v-if="index != scope.row.value.length - 1">、</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="60"
          :resizable="false"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">修改</el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="loading-box" v-if="isLoading">
            <img
              src="../../../../assets/image/loading.png"
              alt="loading"
              class="loading-ico"
            />
            数据加载中...
          </div>
          <div class="empty-box" v-if="!isLoading && !settingData.length">
            列表为空
          </div>
        </template>
      </el-table>
    </div>
    <el-dialog
      :title="titleText"
      :visible.sync="isEditSetting"
      class="setting-dialog"
    >
      <div class="tip-box">
        <i class="el-icon-warning"></i>
        注意，调整该选择会同时调整目前已使用该选择的客源配置相关数据，请谨慎操作。
      </div>
      <el-table
        :data="settingData"
        border
        class="setting-table"
        row-key="index"
      >
        <el-table-column label="选项值" :resizable="false">
          <template slot-scope="scope">
            <el-input
              :class="{ 'error-input': scope.row.error }"
              v-model="scope.row.option"
              placeholder="请输入选项值名称"
              @blur="settingBlur(scope.row)"
              @change="settingChange(scope.row)"
              :disabled="scope.row.isDefault"
              clearable
            ></el-input>
            <span class="rule-tip" v-if="scope.row.error"
              >*请输入选项值名称</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="135" :resizable="false">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="moveUp(scope.$index)"
              v-if="scope.$index != 0"
              >上移</el-button
            >
            <el-button
              type="text"
              @click="moveDown(scope.$index)"
              v-if="scope.$index != settingData.length - 1"
              >下移</el-button
            >
            <!-- <el-button
              type="text"
              class="del-btn"
              @click="deleteSetting(scope.$index)"
              v-if="!scope.row.isDefault"
              >删除</el-button
            > -->
            <el-popover placement="bottom" trigger="click">
              <el-button
                @click.native.prevent="deleteSetting(scope.$index)"
                type="text"
                class="del-btn"
                >删除</el-button
              >
              <el-button
                slot="reference"
                type="text"
                class="more-btn"
                v-if="!scope.row.isDefault"
                >更多</el-button
              >
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <div class="add-setting" @click="addSetting">
          <i class="el-icon-plus"></i>添加选项值
        </div>
        <div>
          <el-button @click="isEditSetting = false">取 消</el-button>
          <el-button type="primary" @click="submitEditSetting">确 定</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      :title="customTitle"
      :visible.sync="isAddCustom"
      class="setting-dialog"
    >
      <div class="custom-form">
        <span class="custom-label"
          >参数项 <span class="error-tip">*</span></span
        >
        <el-input
          v-model="customForm.option"
          class="custom-name"
          @blur="settingBlur(customForm)"
          @change="settingChange(customForm)"
        >
        </el-input>
        <span class="rule-tip" v-if="customForm.error">*请输入选项值名称</span>
      </div>
      <el-table
        :data="settingsCustomData"
        border
        class="setting-table custom-table"
        row-key="index"
      >
        <el-table-column label="选项值" :resizable="false">
          <template slot-scope="scope">
            <el-input
              :class="{ 'error-input': scope.row.error }"
              v-model="scope.row.option"
              placeholder="请输入选项值名称"
              @blur="settingBlur(scope.row)"
              @change="settingChange(scope.row)"
              clearable
            ></el-input>
            <span class="rule-tip" v-if="scope.row.error"
              >*请输入选项值名称</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" width="135" :resizable="false">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="customMoveUp(scope.$index)"
              v-if="scope.$index != 0"
              >上移</el-button
            >
            <el-button
              type="text"
              @click="customMoveDown(scope.$index)"
              v-if="scope.$index != settingsCustomData.length - 1"
              >下移</el-button
            >
            <!-- <el-button
              type="text"
              class="del-btn"
              @click="deleteCustomSetting(scope.$index)"
              v-if="!scope.row.isDefault"
              :disabled="settingsCustomData.length < 2"
              >删除</el-button
            > -->
            <el-popover placement="bottom" trigger="click">
              <el-button
                @click.native.prevent="deleteCustomSetting(scope.$index)"
                :disabled="settingsCustomData.length < 2"
                type="text"
                class="del-btn"
                >删除</el-button
              >
              <el-button
                slot="reference"
                type="text"
                class="more-btn"
                v-if="!scope.row.isDefault"
                >更多</el-button
              >
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <div class="add-setting" @click="addCustomSetting">
          <i class="el-icon-plus"></i>添加选项值
        </div>
        <div>
          <el-button @click="isAddCustom = false">取 消</el-button>
          <el-button type="primary" @click="submitAddCustom">确 定</el-button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTransactionSettings,
  updateTransactionSettings,
} from "@/http/api/system";
import { deepCopy } from "@/utils/deepCopy";
import Sortable from "sortablejs";

export default {
  props: {
    isEdit: { type: Boolean },
  },
  data() {
    return {
      titleText: "",
      customTitle: "",
      settingName: "",
      isLoading: true,
      isEditSetting: false,
      isAddCustom: false,
      customName: "",
      customForm: {
        option: "",
        error: false,
      },
      permissions: this.$store.getters.permissions,
      settingsData: [],
      settingData: [],
      customData: [],

      settingsAchievementPlanParamData: [],
      settingsCapitalParamData: [],
      settingsMaterialParamData: [],
      settingsCustomData: [
        {
          option: "",
          error: false,
        },
      ],
      index: 0,
      customIndex: 0,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getSettingData();
      // 阻止默认行为
      document.body.ondrop = function (event) {
        event.preventDefault();
        event.stopPropagation();
      };
    },
    // 提交新增自定义参数回调
    submitAddCustom() {
      let status = this.settingsCustomData.some((el) => {
        return el.option.trim() == "";
      });
      let valueArr = [];
      this.settingsCustomData.map((el) => {
        if (!el.option.trim()) {
          el.error = true;
        }
        valueArr.push(el.option);
      });
      if (!this.customForm.option) {
        this.customForm.error = true;
      }
      if (!status && this.customForm.option) {
        let obj = {
          name: this.customForm.option,
          value: valueArr.join("、"),
        };
        if (this.customTitle == "新增自定义参数") {
          this.customData.push(obj);
        } else {
          this.customData.splice(this.customIndex, 1, obj);
        }
        this.$message.success({
          message: "提交成功",
          showClose: true,
        });
        this.isAddCustom = false;
      }
    },
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(
        ".setting-table .el-table__body-wrapper tbody"
      );
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const targetRow = _this.settingData.splice(oldIndex, 1)[0];
          _this.settingData.splice(newIndex, 0, targetRow);
        },
      });
    },
    //自定义参数行拖拽
    rowDropCustom() {
      const tbodyCustom = document.querySelector(
        ".custom-table .el-table__body-wrapper tbody"
      );
      const _this = this;
      Sortable.create(tbodyCustom, {
        onEnd({ newIndex, oldIndex }) {
          const targetRow = _this.settingsCustomData.splice(oldIndex, 1)[0];
          _this.settingsCustomData.splice(newIndex, 0, targetRow);
          //console.log(666888);
        },
      });
    },
    // 删除
    deleteSetting(i) {
      this.settingData.splice(i, 1);
      //console.log(this.settingData, "this.settingData");
    },
    // 自定义参数值删除
    deleteCustomSetting(i) {
      if (this.settingsCustomData.length > 1) {
        this.settingsCustomData.splice(i, 1);
      }
    },
    // 自定义参数删除
    deleteCustom(i) {
      this.customData.splice(i, 1);
    },
    // 下移
    moveDown(i) {
      this.swapItems(this.settingData, i, i + 1);
    },
    // 自定义参数下移
    customMoveDown(i) {
      this.swapItems(this.settingsCustomData, i, i + 1);
    },
    // 上移
    moveUp(i) {
      this.swapItems(this.settingData, i, i - 1);
    },
    // 自定义参数上移
    customMoveUp(i) {
      this.swapItems(this.settingsCustomData, i, i - 1);
    },
    // 数组内交换位置
    swapItems(arr, index1, index2) {
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
    },
    // 修改
    edit(v) {
      if (this.permissions["System.TransactionSettings.Update"]) {
        this.titleText = "修改" + v.displayName;
        let arr = deepCopy(v.value);
        if (arr) {
          arr.map((el, index) => {
            el.error = false;
            el.index = index;
          });
        } else {
          arr = [];
        }
        this.settingData = arr;
        this.settingName = v.name;
        this.isEditSetting = true;
        this.$nextTick(() => {
          this.rowDrop();
        });
      } else {
        this.$message.warning({
          message: `您暂无更新交易设置权限`,
          showClose: true,
        });
      }
    },
    // 修改自定义参数
    editCustom(v, i) {
      //console.log(v, 666);
      this.customIndex = i;
      this.customTitle = "修改自定义参数" + v.name;
      this.customForm = {
        option: v.name,
        error: false,
      };
      this.isAddCustom = true;
      let arr = [];
      v.value.split("、").map((el) => {
        arr.push({
          option: el,
          error: false,
          index: this.index++,
        });
      });
      this.settingsCustomData = arr;
      // this.$nextTick(() => {
      //   this.rowDropCustom();
      // });
    },
    // 获取基础字段
    getSettingData() {
      this.isLoading = true;
      this.settingsData = [];
      this.settingsAchievementPlanParamData = [];
      this.settingsCapitalParamData = [];
      this.settingsMaterialParamData = [];
      getTransactionSettings()
        .then((res) => {
          res.result.map((item) => {
            if (item.isCollection) {
              this.settingsData.push(item);
            }
          });
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
      let query = [
        { type: "AchievementPlanParam" }, //业绩分成类参数
        { type: "CapitalParam" }, //资金类参数
        { type: "MaterialParam" }, //附件类参数
      ];
      getTransactionSettings(query[0])
        .then((res) => {
          res.result.map((item) => {
            if (item.isCollection) {
              this.settingsAchievementPlanParamData.push(item);
            }
          });
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
      getTransactionSettings(query[1])
        .then((res) => {
          res.result.map((item) => {
            if (item.isCollection) {
              this.settingsCapitalParamData.push(item);
            }
          });
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
      getTransactionSettings(query[2])
        .then((res) => {
          res.result.map((item) => {
            if (item.isCollection) {
              this.settingsMaterialParamData.push(item);
            }
          });
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },

    // 提交修改设置项
    submitEditSetting() {
      let status = this.settingData.some((el) => {
        return el.option.trim() == "";
      });
      let valueArr = [];
      this.settingData.map((el) => {
        if (!el.option.trim()) {
          el.error = true;
        }
        valueArr.push(el.option);
      });
      if (!status) {
        let data = {
          settings: [
            {
              name: this.settingName,
              value: valueArr.join("|"),
              isCollection: true,
              forceToSet: true,
            },
          ],
        };
        updateTransactionSettings(
          this.$store.getters.generateUpdateSettingsParams,
          data
        ).then((res) => {
          if (res) {
            this.$message.success({
              message: `修改成功`,
              showClose: true,
            });
          }
          this.getSettingData();
          this.isEditSetting = false;
        });
      }
    },
    addSetting() {
      this.settingData.push({
        isDefault: false,
        error: false,
        option: "",
      });
    },
    addCustomSetting() {
      this.settingsCustomData.push({
        error: false,
        option: "",
        index: this.index++,
      });
    },
    settingBlur(v) {
      if (!v.option.trim()) {
        v.error = true;
      }
    },
    settingChange(v) {
      if (v.option.trim()) {
        v.error = false;
      }
    },
    // 新增自定义参数
    addCustomParameter() {
      this.isAddCustom = true;
      this.customName = "";
      this.settingsCustomData = [
        {
          option: "",
          error: false,
        },
      ];
      this.customForm = {
        option: "",
        error: false,
      };
      this.customTitle = "新增自定义参数";

      // this.$nextTick(() => {
      //   this.rowDropCustom();
      //   //console.log("自定义拖拽");
      // });
    },
  },
};
</script>

<style lang="scss" scoped>
.transaction-parameter {
  // padding-bottom: 20px;
  .setting-box {
    margin-bottom: 20px;
    padding-bottom: 20px;
    background: #fff;
    .title {
      margin-bottom: 20px;
      padding: 20px;
      border-bottom: 1px solid #e0e0e0;
      font-size: 15px;
    }

    .custom {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .title-tip {
      margin-left: 50px;
      font-size: 14px;
      color: #666;
    }

    ::v-deep .el-table {
      margin: 20px;
      margin-bottom: 30px;
      width: calc(100% - 45px);

      .el-table__header {
        th {
          background-color: #f2f2f2;
        }

        th {
          padding: 7px 0;
        }
      }

      td {
        padding: 7px 0;
      }

      .el-table__row {
        .cell {
          .setting-value {
            color: #000;
          }

          .setting-default {
            color: #888;
          }
        }
      }
    }
    .custom-table {
      margin-bottom: 0;
      min-width: 500px;

      .el-button.is-disabled {
        border-color: transparent;
        background-color: transparent;
      }
    }
  }
  .last {
    margin-bottom: 0px;
  }

  .setting-dialog {
    ::v-deep .el-dialog__body {
      overflow-y: auto;
      margin-right: 0;
      padding-right: 20px;
      max-height: calc(100vh - 250px);

      .tip-box {
        margin-bottom: 16px;
        border: 1px solid rgb(254, 229, 143);
        padding: 8px 16px;

        font-size: 12px;
        color: rgb(51, 51, 51);
        background-color: rgb(255, 251, 230);

        i {
          font-size: 14px;
          vertical-align: middle;
          color: rgb(247, 186, 42);
        }
      }

      .el-table {
        .el-input {
          width: 180px;

          &.error-input {
            .el-input__inner {
              border-color: #f56c6c !important;
            }
          }
        }
      }

      .rule-tip {
        margin-left: 5px;
        color: #f56c6c;
      }

      .custom-form {
        margin-bottom: 16px;
        width: 500px;

        .error-tip {
          margin-left: 1px;
          color: #f56c6c;
        }

        .custom-name {
          width: 180px;
        }

        .custom-label {
          display: inline-block;
          width: 5rem;
        }
      }
    }

    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .add-setting {
        color: $--color-primary;
        cursor: pointer;

        i {
          margin-right: 2px;
        }

        .required-item {
          margin-left: 4px;
          color: #f56c6c;
        }
      }
    }
  }
}
</style>